import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRadiusGeometry } from "features/MarketAreas/types";
import { resetMarketAreaDrawing } from "../resetMarketAreaDrawing";
import { TDrawnPosition } from "../types";

type TMarketAreaRadiusState = {
  drawnPosition: TDrawnPosition | null;
  editedGeometry: IRadiusGeometry | null;
};

const initialState: TMarketAreaRadiusState = {
  drawnPosition: null,
  editedGeometry: null,
};

const marketAreaRadiusSlice = createSlice({
  name: "marketAreaRadius",
  initialState,
  reducers: {
    setDrawnPosition: (
      state,
      { payload }: PayloadAction<TDrawnPosition | null>
    ) => {
      state.drawnPosition = payload;
    },
    setRadiusEditedGeometry: (
      state,
      { payload }: PayloadAction<IRadiusGeometry | null>
    ) => {
      state.editedGeometry = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetMarketAreaDrawing, () => initialState);
  },
});

export const { setDrawnPosition, setRadiusEditedGeometry } =
  marketAreaRadiusSlice.actions;

export default marketAreaRadiusSlice;
